import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import indexRoutes from "routes/index.jsx";
import "./assets/css/fonts.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-rtl/dist/css/bootstrap-rtl.min.css";
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard.css?v=1.2.0";
import "./assets/css/demo.css";
import "./assets/css/app.css";
import "./assets/css/pe-icon-7-stroke.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import "react-notifications/lib/notifications.css";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import "@fortawesome/fontawesome-free/css/fontawesome.css";

window.store = store;
ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        {indexRoutes.map((prop, key) => {
          return <Route to={prop.path} component={prop.component} key={key} />;
        })}
        <Redirect to="/" />
        {/* <Route path={"/dashboard"} component={Dashboard}/> */}
        {/* <Route path={"/customerinfo"} component={CustomerInfo}/> */}
      </Switch>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
